/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ThirdPartyNetwork } from '../../models/third-party-network';
import { ThirdPartyNetworkApiRespModel } from '../../models/third-party-network-api-resp-model';

export interface ApiMasterThirdPartyNetworkAddPost$Params {
      body?: ThirdPartyNetwork
}

export function apiMasterThirdPartyNetworkAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterThirdPartyNetworkAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ThirdPartyNetworkApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterThirdPartyNetworkAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ThirdPartyNetworkApiRespModel>;
    })
  );
}

apiMasterThirdPartyNetworkAddPost.PATH = '/api/Master/ThirdPartyNetwork/Add';
